
import { defineComponent, ref } from 'vue';

import FormularioUsuarios from "./forms/usuarios/FormularioUsuarios.vue";

import UsuariosTable from "./components/UsuariosTable.vue";

import fintailapi from "../api";

import { useToast } from "vue-toastification";

export default defineComponent({
  name: "tables",
  components: {
    FormularioUsuarios,
    UsuariosTable
  },
  data() {
    return {
      rows: [],
      data:{ id: "-" },
      editando:false,
      niveis:[],
      operacoes:[],
      current_page: 0,
      offset:0,
      current_offset:0,
      total_count: 0,
      total_pages: 0,
      operadores:[],
      toast : useToast()
    };
  },
  methods: {
    getUnico(id:any) {

      fintailapi
        .get(`/usuarios/${id}`)
        .then((response:any) => {

          this.data = response.data

          this.editando = true;
          //this.getNiveis()

        })
        .catch((error:any) => {

        })
    },
    salvarUnico(usuario:any) {

        fintailapi
        .put(`/usuarios/${usuario.id}`, usuario)
        .then((response:any) => {

          this.data = {id:"-"}
          this.editando = false;
          this.getPaginas(this.current_offset)

        })
        .catch((error:any) => {
          this.toast.error(`Erro: ${ error.response.data.error }, tente novamente.`);
        })

    },
    deleteUnico(id:any) {
      fintailapi
        .delete(`/usuarios/${id}`)
        .then((response:any) => {

          this.toast.success("Usuário excluído com sucesso");
          this.getPaginas(this.current_offset)

        })
        .catch((error:any) => {
          this.toast.error("Erro ao excluir Usuário, tente novamente.");
        })
    },
    searchCall(campo:any, termo:any) {

      fintailapi
        .get(`/usuarios/pesquisar/campo?term=${termo}&field=${campo}`)
        .then((response:any) => {
          this.current_offset = 0;
          this.current_page = 0 / 10; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / 10);
          this.rows = response.data.rows;
        })
        .catch((error:any) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
    fecharUnico() {

        this.data = {id:"-"}
        this.$router.push('/usuarios');
        this.editando = false;
        

    },
    getPaginas(offset:number) {

      
        if (this.total_count > 0 && (offset < 0 || offset >= this.total_count)) return; // Impede valores inválidos


        this.current_offset = offset;

        fintailapi
        .get(`/usuarios?offset=${offset}&limit=10`)
        .then((response:any) => {

          this.current_page = offset / 10; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / 10);
          this.rows = response.data.rows;

          this.getOperadores();
        
        })
        .catch((error:any) => {



        })

    },
    getOperadores() {

          fintailapi
          .get(`/operadores`)
          .then(async(response) => {

              this.operadores = response.data.rows;

          })
          .catch((error) => {

            console.log(error)
            //this.isOpenRef = true;

          })

    },

    getNiveis() {

      fintailapi
        .get(`/usuarios/nivel`)
        .then((response:any) => {
          this.niveis = response.data
          this.getOperacoes(0)
        })
        .catch((error:any) => {

        })
    },
    getOperacoes(offset:number) {

      fintailapi
      .get(`/operacoes?offset=${offset}&limit=100&ativas=true`)
      .then((response:any) => {
        this.operacoes = response.data.rows
      })
      .catch((error:any) => {

      })

    },
   },
   created() {

      let modo = this.$route.params.id || 'view';

      if(modo == "criar"){

        this.data.id = "";
       

      } 

      this.getNiveis();
      this.getPaginas(0)

   },

});


